import React from "react";
import ShopCategory from "./[category]";

const AllNewArrivals = () => {
    return <ShopCategory />;
};

export default AllNewArrivals;
